export default __webpack_public_path__ + "static/media/msync2.b496dee0.png";